<template>
  <VueTelInput
    ref="component"
    :value="value"
    defaultCountry="es"
    :autoDefaultCountry="false"
    :autoFormat="false"
    :dropdownOptions="{
      showDialCodeInList: true,
      showDialCodeInSelection: false,
      showFlags: true,
      disabled: isDisabledFlags,
    }"
    :inputOptions="{
      autocomplete,
      id,
      maxlength: 25,
      name,
      placeholder,
    }"
    mode="auto"
    :preferredCountries="preferredCountries"
    :styleClasses="{
      'with-errors': error,
      'input-wrapper phone-input-alo': true,
    }"
    @focus="onFocus"
    @blur="onBlur"
    @country-changed="onCountryChanged"
    @input="onInput"
  />
</template>

<script>
const VueTelInput = () =>
  Promise.all([import('vue-tel-input'), import('vue-tel-input/dist/vue-tel-input.css')]).then(
    ([{ VueTelInput }]) => VueTelInput
  )

export default {
  components: {
    VueTelInput,
  },

  props: {
    value: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    autocomplete: {
      type: String,
      default: 'tel',
    },
    isDisabledFlags: {
      type: Boolean,
      default: false,
    },
    error: {
      type: Object,
      default: null,
    },
    setError: {
      type: Function,
      default() {
        return null
      },
    },
  },

  data() {
    return {
      focused: false,
      formattedNumber: '',
      lastDialCode: '',
      preferredCountries: [
        'es',
        'ad',
        'at',
        'dk',
        'fr',
        'de',
        'ie',
        'it',
        'lu',
        'nl',
        'no',
        'pl',
        'pt',
        'se',
        'ch',
        'gb',
      ],
    }
  },

  computed: {
    proxyValue: {
      get() {
        return this.value
      },

      set(value) {
        this.$emit('input', value)
      },
    },
  },

  methods: {
    onFocus() {
      this.focused = true
    },
    onBlur() {
      this.focused = false
      this.$emit('input', this.formattedNumber)

      const regex =
        'phone_portability' !== this.name
          ? /^\+(30|31|32|33|34|35[0-9]|36|37[0-9]|38[0-9]|39|40|41|42|43|44|45|46|47|48|49|5[0123456789])\s?(6\d{7,9}|7\d{7,9}|15\d{8,9}|16\d{8,9}|17\d{8,9}|3\d{8,9})$/ // Europe mobile phone
          : /^\+34\s?(6\d{8}|7\d{8})$/ // Spain mobile phone
      if ('shipping_address_phone' !== this.name) {
        if (!regex.test(this.formattedNumber)) {
          if ('phone_portability' !== this.name) {
            this.$emit('setError', 'El campo teléfono no es válido, debe ser un teléfono móvil europeo.')
          } else {
            this.$emit('setError', 'El campo teléfono no es válido, debe ser un teléfono móvil español.')
          }
        } else {
          this.$emit('setError', '')
        }
      }
    },
    onCountryChanged(country) {
      // Emit input on country changed
      this.$refs['component'].emitInput()
      this.$emit('input', this.formattedNumber)
    },
    onInput(number, phone) {
      this.formattedNumber = phone.nationalNumber ? '+' + phone.countryCallingCode + ' ' + phone.nationalNumber : ''
    },
  },
}
</script>

<style lang="scss" scoped>
.input-wrapper {
  @apply mt-1 shadow-sm sm:text-sm border-gray-300 rounded-md #{!important};

  ::v-deep input {
    padding: 0.5rem 0.75rem;
    @apply text-base sm:text-sm rounded-md;
  }
}
</style>
